export default __webpack_public_path__ + "static/media/Blog12.1.26c3490d.png";